import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const DocumentSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 28 28"
  >
    <g fill="none">
      <path
        fill="url(#SVGzJOHPduk)"
        d="M15 2H6.5A2.5 2.5 0 0 0 4 4.5v19A2.5 2.5 0 0 0 6.5 26h15a2.5 2.5 0 0 0 2.5-2.5V11l-7-2z"
      ></path>
      <path
        fill="url(#SVGoE5mSdPK)"
        fillOpacity={0.5}
        d="M15 2H6.5A2.5 2.5 0 0 0 4 4.5v19A2.5 2.5 0 0 0 6.5 26h15a2.5 2.5 0 0 0 2.5-2.5V11l-7-2z"
      ></path>
      <path
        fill="url(#SVGoE5mSdPK)"
        fillOpacity={0.3}
        d="M15 2H6.5A2.5 2.5 0 0 0 4 4.5v19A2.5 2.5 0 0 0 6.5 26h15a2.5 2.5 0 0 0 2.5-2.5V11l-7-2z"
      ></path>
      <path
        fill="url(#SVGXDkOuPsB)"
        d="M15 9.5V2l9 9h-7.5A1.5 1.5 0 0 1 15 9.5"
      ></path>
      <path
        fill="url(#SVGTngwAdRd)"
        d="M15 9.5V2l9 9h-7.5A1.5 1.5 0 0 1 15 9.5"
      ></path>
      <defs>
        <linearGradient
          id="SVGzJOHPduk"
          x1={18}
          x2={19.388}
          y1={2}
          y2={20.598}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6ce0ff"></stop>
          <stop offset={1} stopColor="#4894fe"></stop>
        </linearGradient>
        <linearGradient
          id="SVGXDkOuPsB"
          x1={19.5}
          x2={19.5}
          y1={2}
          y2={11}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#d9d9d9"></stop>
          <stop offset={1} stopColor="#737373"></stop>
        </linearGradient>
        <linearGradient
          id="SVGTngwAdRd"
          x1={19.485}
          x2={17.235}
          y1={5.75}
          y2={9.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ff0f9"></stop>
          <stop offset={1} stopColor="#b3e0ff"></stop>
        </linearGradient>
        <radialGradient
          id="SVGoE5mSdPK"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(133.966 11.833 6.65)scale(16.325 9.64965)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.362} stopColor="#4a43cb"></stop>
          <stop offset={1} stopColor="#4a43cb" stopOpacity={0}></stop>
        </radialGradient>
      </defs>
    </g>
  </svg>
);
const DocumentIcon = (props: CustomIconComponentProps) => (
  <Icon component={DocumentSvg} {...props} />
);
export default DocumentIcon;
